import React, { memo } from 'react';
import { FormWrapperLabel, FormWrapperMinimum } from '../FormEntryWrapper/FormEntryWrapper';
import { useFormContext } from 'react-hook-form';
import PhoneInputWithCountry from 'react-phone-number-input/react-hook-form';
import { isValidPhoneNumber } from 'react-phone-number-input';

interface TelephoneControlType {
	label: string;
	labelExtra?: string;
	name: string;
	forwardStatus: (state: boolean) => void;

	defaultValue?: any;
	fieldIndex?: number;

	editable?: boolean;
	minimal?: boolean;

	required?: boolean;
	onChange?: any;
}

const TelephoneControl = memo((props: TelephoneControlType) => {
	const { control, formState } = useFormContext();

	return (
		<>
			{props.minimal ? (
				<FormWrapperMinimum
					invalid={formState.errors[props.name]}
					validationMessage={(formState.errors[props.name]?.message as string) || undefined}
				>
					<PhoneInputWithCountry
						name={props.name}
						control={control}
						placeholder='Enter phone number'
						defaultValue={props.defaultValue}
						rules={{
							required: { value: props.required || false, message: 'Telephone is required' },
							validate: (e: any) => (e ? isValidPhoneNumber(e) : props.required !== true),
						}}
					/>
				</FormWrapperMinimum>
			) : (
				<FormWrapperLabel
					label={props.label}
					labelExtra={props.labelExtra}
					invalid={formState.errors[props.name]}
					validationMessage={(formState.errors[props.name]?.message as string) || undefined}
				>
					<PhoneInputWithCountry
						control={control}
						name={props.name}
						placeholder='Enter phone number'
						defaultValue={props.defaultValue}
						rules={{
							required: { value: props.required || false, message: 'Telephone is required' },
							validate: (e: any) => (e ? isValidPhoneNumber(e) : props.required !== true),
						}}
					/>
				</FormWrapperLabel>
			)}
		</>
	);
});

export default TelephoneControl;
